import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, ProductsListsContext, AlertModal, ModalHelper, helper}  from "./../app.js"; 

export default class StudAddSelecter extends PureComponent 
{
    static contextType = ProductsListsContext;

    modal = null;

    constructor (props)
    {
        super(props);

        const hasStudAdd = !helper.isNotObjectOrEmpty(this.props.init_stud_add);

        this.state = {
            stud_adds: {},
            stud_add_conns: [],
            id: hasStudAdd ? this.props.init_stud_add.id : '',
            loading: false,
            alert_message: ''
        };

        this.modal = new ModalHelper(this);

        this.isActive = this.isActive.bind(this);
        this.selectStudAdd = this.selectStudAdd.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    isActive ()
    {
        return this.props.stud_articul;
    }
    loadStudAdds ()
    {
        if (this.isActive())    
        {
            const queryParams = {stud_articul: this.props.stud_articul};

            this.setState({loading: true});

            Server.instance
                .query('get_stud_adds', queryParams)
                .then((recievedStudAdds) =>
                {
                    //console.log(recievedStudAdds);
                    helper.setStateWithRecievedItems(this, 'stud_adds', recievedStudAdds, function (fields, product)
                    {
                        product.quantity_multiple = 'multiple' in fields ? helper.toNumber(fields['multiple']) : 1;
                        if (!product.quantity_multiple) product.quantity_multiple = 1;
                    });
                })
                .catch(() => this.setState({stud_adds: {}, loading: false}));
        }        
    }
    loadStudAddConn (id = '')
    {
        if (!id) id = this.state.id;

        const studAdd = id && id in this.state.stud_adds ? this.state.stud_adds[id] : null,
            hasStudAdd = !helper.isNotObjectOrEmpty(studAdd),
            studAddArticul = hasStudAdd ? studAdd.articul : '',
            studArticul = this.props.stud_articul;

        if (studArticul && studAddArticul)
        {
            const queryParams = {stud_articul: studArticul, add_articul: studAddArticul};

            this.setState({loading: true});

            Server.instance
                .query('get_stud_add_conns', queryParams)
                .then((recievedStudAddConn) =>
                {
                    const studAddConns = helper.setStateWithRecievedItems(this, 'stud_add_conns', recievedStudAddConn); 
                    this.props.on_select(studAddConns, 'stud_add_conns', false);
                })
                .catch(() => {
                    this.setState({stud_add_conns: [], loading: false});
                    this.props.on_select([], 'stud_add_conns', false);
                });
        }
    }
    selectStudAdd (e)
    {
        const id = e.target.value,
            newStudAdd = id ? helper.copyObject(this.state.stud_adds[id]) : null;

        if (!helper.isNotObjectOrEmpty(newStudAdd))
        {
            this.setState({id});
            this.loadStudAddConn(id);
            this.props.on_select(newStudAdd, 'stud_add');
        } 
        else
        {
            this.setState({id, stud_add_conns: []});
            this.props.on_select(null, 'stud_add');
        }
    }
    componentDidMount() 
    {
        this.loadStudAdds();
        this.loadStudAddConn();
    }
    render () 
    {   
        const studAddsList = Object.keys(this.state.stud_adds).map(id => 
                {
                    return <option key={id} value={id}>{'articul' == this.context ? this.state.stud_adds[id].articul : this.state.stud_adds[id].name}</option>;
                }),
            disabled = !this.isActive() || !studAddsList.length;

        studAddsList.unshift(<option key="none" value="">Не требуется</option>);

        return  <><Form.Group as={Col} md={6}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Дополнительный элемент:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectStudAdd} onClick={this.modal.showProjectChangeWarning} value={this.state.id} disabled={disabled} as="select" custom>
                        {studAddsList}
                    </Form.Control>
                </Form.Group>
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
    }
}
